import "./hb-signin.module.css";
import { html } from "lit-html";
import Strings from "../../../models/Strings.json";
import { isPopup, getPrivateName } from "../../global";

export default (user, lang) => html`
    <div
        id="hb-signin"
        tabindex="-1"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-md max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        ${getPrivateName() || Strings.signin[lang]}
                    </h3>
                    <div>
                        <a
                            id="hb-signin-passkey"
                            href="#/passkey"
                            class="mr-2 text-lg"
                            >🔑</a
                        >
                        <button
                            type="button"
                            class="${isPopup
                                ? "hidden"
                                : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="hb-signin">
                            <svg
                                class="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                            </svg>
                            <span class="sr-only">${Strings.close[lang]}</span>
                        </button>
                    </div>
                </div>
                <!-- Modal body -->
                <div class="p-4 md:p-5">
                    <form class="space-y-4">
                        <div>
                            <label
                                for="hb-signin-email"
                                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                >${Strings.signin1[lang]}:
                            </label>
                            <input
                                type="email"
                                autocomplete="username"
                                id="hb-signin-email"
                                class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                placeholder="${user?.email ||
                                "thank@heartbank.com"}"
                                required />
                        </div>
                        <div>
                            <label
                                for="hb-signin-code"
                                class="hidden mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                >${Strings.signin2[lang]}:
                            </label>
                            <button
                                id="hb-signin-button"
                                type="button"
                                class="w-full mb-2 text-white dark:text-black bg-gray-600 dark:bg-gray-100 hover:bg-gray-600/50 focus:ring-4 focus:outline-none focus:ring-gray-600/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                                ${Strings.signin3[lang]}
                            </button>
                            <section
                                id="hb-signin-password"
                                class="hidden mb-2 w-full justify-between">
                                <input
                                    type="password"
                                    autocomplete="new-password"
                                    id="hb-signin-code"
                                    class="mr-1 w-full outline-0 bg-gray-50 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                    placeholder="******"
                                    required />
                                <button
                                    id="hb-signin-show"
                                    type="button"
                                    class="text-white dark:text-black bg-gray-600 dark:bg-gray-100 hover:bg-gray-600/50 focus:ring-4 focus:outline-none focus:ring-gray-600/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                                    ${Strings.signin5[lang]}
                                </button>
                            </section>
                        </div>
                        <button
                            type="submit"
                            class="hidden w-full text-white dark:text-white bg-blue-700 dark:bg-blue-600 hover:bg-blue-700/50 focus:ring-4 focus:outline-none focus:ring-blue-700/25 font-medium rounded-lg text-sm px-4 py-2 text-center"
                            class2="w-full text-white dark:text-black bg-gray-700 dark:bg-gray-50 hover:bg-gray-700/50 focus:ring-4 focus:outline-none focus:ring-gray-700/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                            ${Strings.signin4[lang]}
                        </button>
                    </form>
                    <p
                        id="hb-signin-message"
                        class="text-sm font-medium mt-5 text-orange-500 dark:text-orange-300"></p>
                </div>
            </div>
        </div>
    </div>
`;
